module.exports = {
  "id": "scoreboard",
  "tutorialLink": "https://makeymakey.com/blogs/blog/new-project-november-invent-with-new-apps",
  "title": "scoreboard",
  "hideCursor": false,
  "scenes": [{
    "id": "main",
    "metadata": "main.json",
    "sb3": "scoreboard.sb3"
  }],
  "levels": [
    "main"    
  ],
  "startingGlitches": [
  ],
  "thumbnail": "/provision/projects/scoreboard/scoreboard.png",
  "category": "games",
  "toolbar":{
    "glitches":[],
    "parts":[]
  }
}
;